module.exports = "/lucky-balls/img/color_betting/purple.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/color_betting/purple.png
// module id = 981
// module chunks = 0